import React, { useState } from "react";
import { AUDIO_TYPES } from "../../data/audioTypes";
import { audioTypesLabel, dateRangeError } from "./creativeTargeting";
import "./NewCreativeModal.css";

export const CREATIVE_INPUT_STYLE = { width:"100%", background:"#FAFAFA", border:"1px solid #E2E2E2", borderRadius:10, padding:"10px 14px", color:"#151515", fontSize:13, outline:"none", boxSizing:"border-box", fontFamily:"inherit" };
export const CREATIVE_LABEL_STYLE = { display:"block", fontSize:11, color:"#7b7b7b", textTransform:"uppercase", letterSpacing:1, marginBottom:6 };

// The start and end dates and the inventory type picker, shared by the new and edit modals.
export function CreativeTargetingFields({ startDate, endDate, audioTypes, onStartDateChange, onEndDateChange, onAudioTypesChange }) {
  const [audioOpen, setAudioOpen] = useState(false);
  const dateError = dateRangeError(startDate, endDate);

  const toggleAudio = (type) => {
    onAudioTypesChange(prev =>
      prev.some(t => t.value === type.value)
        ? prev.filter(t => t.value !== type.value)
        : [...prev, { ...type, clusivity:"include" }]
    );
  };

  const toggleClusivity = (e, type) => {
    e.stopPropagation();
    onAudioTypesChange(prev =>
      prev.map(t => t.value === type.value ? { ...t, clusivity: t.clusivity === "include" ? "exclude" : "include" } : t)
    );
  };

  return (
    <>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom: dateError ? 8 : 16 }}>
        <div>
          <label htmlFor="creative-start-date" style={CREATIVE_LABEL_STYLE}>Start date (optional)</label>
          <input id="creative-start-date" type="date" value={startDate} onChange={e => onStartDateChange(e.target.value)} style={CREATIVE_INPUT_STYLE} />
        </div>
        <div>
          <label htmlFor="creative-end-date" style={CREATIVE_LABEL_STYLE}>End date (optional)</label>
          <input id="creative-end-date" type="date" value={endDate} onChange={e => onEndDateChange(e.target.value)} style={CREATIVE_INPUT_STYLE} />
        </div>
      </div>
      {dateError && <div style={{ fontSize:12, color:"#e53935", marginBottom:16 }}>{dateError}</div>}

      <div style={{ marginBottom:20 }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:8 }}>
          <label style={{ fontSize:11, color:"#7b7b7b", textTransform:"uppercase", letterSpacing:1 }}>Inventory Types</label>
          <button type="button" onClick={() => setAudioOpen(o => !o)} style={{ fontSize:12, color:"#F90091", background:"none", border:"none", cursor:"pointer", padding:0 }}>
            {audioOpen ? "Done" : "Edit"}
          </button>
        </div>
        <div style={{ fontSize:13, color:"#151515", fontWeight:500, marginBottom: audioOpen ? 10 : 0 }}>{audioTypesLabel(audioTypes)}</div>
        {audioOpen && (
          <div className="ncm-reveal" style={{ display:"flex", flexDirection:"column", gap:8, marginTop:8 }}>
            {AUDIO_TYPES.map(type => {
              const active = audioTypes.find(t => t.value === type.value);
              const isExclude = active?.clusivity === "exclude";
              const borderColor = active ? (isExclude ? "#e53935" : "#F90091") : "#E2E2E2";
              return (
                <div key={type.value} onClick={() => toggleAudio(type)}
                  style={{ display:"flex", alignItems:"center", gap:10, padding:"8px 12px", background:"#FAFAFA", borderRadius:8, cursor:"pointer", border:`1px solid ${borderColor}` }}>
                  <div style={{ width:16, height:16, borderRadius:4, background: active ? (isExclude ? "#e53935" : "#F90091") : "#F0F0F0", border:`1px solid ${active ? (isExclude ? "#e53935" : "#F90091") : "#CFCFCF"}`, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                    {active && <span style={{ color:"#fff", fontSize:10, lineHeight:1 }}>✓</span>}
                  </div>
                  <span style={{ fontSize:13, color: active ? "#151515" : "#626262", flex:1 }}>{type.display_name}</span>
                  {active && (
                    <button
                      type="button"
                      onClick={(e) => toggleClusivity(e, active)}
                      style={{ fontSize:10, padding:"2px 8px", borderRadius:4, border:`1px solid ${isExclude ? "#e53935" : "#F90091"}`, background: isExclude ? "#FFF5F5" : "#FFF5FB", color: isExclude ? "#e53935" : "#F90091", cursor:"pointer", fontWeight:600, textTransform:"uppercase", letterSpacing:0.5 }}
                    >
                      {isExclude ? "exclude" : "include"}
                    </button>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </>
  );
}
